import { render, staticRenderFns } from "./KegIndex.vue?vue&type=template&id=74def712&scoped=true"
import script from "./KegIndex.vue?vue&type=script&lang=js"
export * from "./KegIndex.vue?vue&type=script&lang=js"
import style0 from "./KegIndex.vue?vue&type=style&index=0&id=74def712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74def712",
  null
  
)

export default component.exports